module.exports = __webpack_public_path__ + "img/3-01-05-a-rd.22c81ebe.svg";